import React, { useState, useRef, useEffect, useCallback, forwardRef } from "react";
import moment from "moment";
import ListPageHeader from "../utilities/ListPageHeader";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Pagination,
  Tooltip,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import jwtDecode from "jwt-decode";
import OAuthService from "src/app/auth/services/oAuthService";
import AgGridTable from "../utilities/AgGridTable";
import NumericCellEditorComponent from "./NumericCellEditorComponent";
import {
  DateFromEditorComponent,
  DateToEditorComponent,
} from "./DatepickerEditorComponent";
import customStyles from 'app/shared-components/SelectCustomStyle';
import { toast } from "react-toastify";
import Select from "react-select";
import { DateTypeEditorComponent, VendorIdEditorComponent } from "./SelectEditorComponent";
import CustomDatePicker from "../utilities/CustomDatePicker";

const TransferDiscount = () => {
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.discounts}`;
  const transferUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.transferDiscounts}`;

  const [rowData, setRowData] = useState([]);
  const [saveOpen, setSaveOpen] = useState(false);
  const [error, setError] = useState(null);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [page, setPage] = useState(0);
const [pageSize, setPageSize] = useState(20);
const [totalElements, setTotalElements] = useState(0);
const [vendorOptions, setVendorOptions] = useState([]);
const vendorOptionsRef = useRef([]);
const [date,setDate] = useState(new Date())

  const token =
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  const showDiscountPercent = (props) =>
    props?.value ? <p>{Number(props?.value).toFixed(3)}%</p> : null;
const formatApiDate = (date) => moment(date).format("YYYY-MM-DD");
  const handleDateFormat = (props) =>
    props?.value ? moment(props?.value).format("DD-MM-YYYY") : "";
const requiredFields = ["vendorId", "validFrom", "validTo", "wg1Discount", "wg2Discount", "dateType"];
const onSelectionChanged = useCallback(() => {
  const selectedNodes = gridRef.current.api.getSelectedNodes();
  const selectedData = selectedNodes.length > 0 ? selectedNodes[0].data : null;
  setSelectedRow(selectedData);
}, []);

useEffect(() => {
  const loadVendors = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}/search/findByActive?active=true`;

    try {
      const vendors = await OAuthService.getList(url);

      const result =
        vendors?.data?._embedded?.factoryVendors?.map((v) => ({
          label: v.name,   
          value: v.id,   
        })) || [];

      setVendorOptions(result);
      vendorOptionsRef.current = result;
    } catch (error) {
      console.error("Vendor fetch error:", error);
    }
  };

  loadVendors();
}, []);
const handleAddRow = () => {
  if (!gridApi) return;

  const newRow = {
    vendorId: "",
    validFrom: "",
    validTo: "",
    wg1Discount: "",
    wg2Discount: "",
    dateType: "",
    isNew: true,
  };

  let addIndex = rowData?.length;
  const selectedNodes = gridApi.getSelectedNodes();

  if (selectedNodes && selectedNodes.length > 0) {
    const selectedNode = selectedNodes[0];
    addIndex = selectedNode.rowIndex + 1;
  }

  const res = gridApi.applyTransaction({
    add: [newRow],
    addIndex,
  });

  setRowData((prev) => {
    const updated = [...prev||[]];
    updated.splice(addIndex, 0, newRow); 
    return updated;
  });

  if (res.add && res.add.length > 0) {
    const newRowNode = res?.add[0];

    setTimeout(() => {
      gridApi.stopEditing();
      gridApi.setFocusedCell(newRowNode.rowIndex, "vendorId");
      gridApi.startEditingCell({
        rowIndex: newRowNode.rowIndex,
        colKey: "vendorId",
      });
    }, 100);
  }
};
 const handleEditRow = useCallback(() => {
    const selectedRow = gridRef.current.api.getSelectedRows();
    let index = rowData.findIndex((row) => row.id === selectedRow[0].id);
    // let index = rowData?.findIndex((row) => row.id === selectedRow[0].id);
    gridRef.current.api.setFocusedCell(index, "vendorId");
    gridRef.current.api.startEditingCell({
      rowIndex: index,
      colKey: "vendorId",
    });
  }, [rowData]);
  const handleSaveDiscount = async () => {
  gridApi.stopEditing();

  try {
    const newRows = rowData.filter((row) => row.isNew);
    const updatedRows = rowData.filter((row) => row.isEdited && !row.isNew);
    if (newRows.length === 0 && updatedRows.length === 0) {
      toast.info("No new or updated discounts to save.");
      setSaveOpen(false);
      return;
    }

    for (const row of newRows) {
      const payload = {
        vendorId: row.vendorId || 0,
        validFrom: row.validFrom
          ? moment(row.validFrom).format("YYYY-MM-DD")
          : null,
        validTo: row.validTo
          ? moment(row.validTo).format("YYYY-MM-DD")
          : null,
        wg1Discount: Number(row.wg1Discount) || 0,
        wg2Discount: Number(row.wg2Discount) || 0,
        dateType: row.dateType || "ORDERPLACED",
      };

      await OAuthService.addData(transferUrl, payload);
    }

    for (const row of updatedRows) {
      const payload = {
        vendorId: row.vendorId || 0,
        validFrom: row.validFrom
          ? moment(row.validFrom).format("YYYY-MM-DD")
          : null,
        validTo: row.validTo
          ? moment(row.validTo).format("YYYY-MM-DD")
          : null,
        wg1Discount: Number(row.wg1Discount) || 0,
        wg2Discount: Number(row.wg2Discount) || 0,
        dateType: row.dateType || "ORDERPLACED",
      };

      await OAuthService.updateData(transferUrl,row.id, payload);
    }

    await loadTransferDiscount();
    toast.success("Discounts saved successfully!");
    setSaveOpen(false);
    setIsSaveEnabled(false); 
    setSelectedRow(null);
  } catch (err) {
    console.error("Error saving discounts:", err);
    toast.error("Failed to save discounts.");
    setSaveOpen(false);
    setIsSaveEnabled(false);
    setSelectedRow(null); 
  }
};
  const handleDateChange=(date)=>{
        const fromDate = date ? moment(date).format("YYYY-MM-DD") : null;
        setDate(fromDate);
  }
 const checkSaveEnabled = (rows) => {
  if (!rows || rows.length === 0) return false;

  return rows.every(row =>
    row.vendorId &&
    row.validFrom &&
    row.validTo &&
    row.wg1Discount !== "" &&
    row.wg2Discount !== "" &&
    row.dateType
  );
};
const validateAllRows = () => {
  return rowData.every((row) => {
    return (
      row.vendorId &&
      row.validFrom &&
      row.validTo &&
      row.dateType &&
      row.wg1Discount !== "" &&
      row.wg2Discount !== "" &&
      !isNaN(Number(row.wg1Discount)) &&
      !isNaN(Number(row.wg2Discount))
    );
  });
};

const onCellEditingStopped = (params) => {
  const { colDef, value, node } = params;

  const updatedRowData = rowData.map((row, idx) =>
    idx === node.rowIndex
      ? {
          ...row,
          [colDef.field]: value,
          isEdited: !row.isNew,
        }
      : row
  );

  setRowData(updatedRowData);

  const enabled = validateAllRows(updatedRowData);
  setIsSaveEnabled(enabled);
};

const handleDeleteDiscount = async () => {
  if (!selectedRow) {
    toast.info("Please select a discount to delete.");
    return;
  }
    if (!selectedRow.id) {
    gridRef.current.api.applyTransaction({ remove: [selectedRow] });
    
     await loadTransferDiscount();
    setDeleteOpen(false);
    setSelectedRow(null);
    return;
  }
  try {
    const deleted = await OAuthService.deleteData(
     transferUrl, selectedRow.id
    );

    if (deleted) {
      gridRef.current.api.applyTransaction({ remove: [selectedRow] });
      
     await loadTransferDiscount();

      toast.success("Discount deleted successfully!");
      setDeleteOpen(false);
      setSelectedRow(null);
    }
  } catch (error) {
  
    toast.error("Failed to delete discount.");
    setDeleteOpen(false);
    setSelectedRow(null);
  }
};
  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "DiscountMaster.xlsx",
      sheetName: "Discount Master",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

 const loadTransferDiscount = async () => {
  gridRef?.current?.api?.showLoadingOverlay();
   const startDate = formatApiDate(date);
   try {
     if (date) {
       const list = await OAuthService.getList(
         `${transferUrl}/search/findByValidFromBeforeAndValidToAfter?date=${startDate}`,
       );
       setRowData(list.data._embedded.transferDiscounts);
     } else {
       const list = await OAuthService.getList(
         `${transferUrl}?page=0&size=1000`,
       );
       setRowData(list.data._embedded.transferDiscounts);
     }
     gridRef?.current?.api?.hideOverlay();

     // setPage(list.data.page.number);
     // setPageSize(list.data.page.size);
     // setTotalElements(list.data.page.totalElements);
   } catch (err) {
     gridRef?.current?.api?.hideOverlay();
     toast.error(err?.response?.data?.errorMessage || err.message);
   }
};
  useEffect(() => {
    loadTransferDiscount();
  }, [date]);
const validateDiscount = (params) => {
  let value = Number(params.newValue);


  if (isNaN(value) || value < 0) {
    toast.warning(`${params.colDef.headerName} cannot be negative`);
    value = 0;
  } else if (value > 100) {
    toast.warning(`${params.colDef.headerName} cannot exceed 100`);
    value = 100;
  }

  params.node.setDataValue(params.colDef.field, value);
};
  const columnDefs = [
    {
      field: "vendorId",
      headerName: "Vendor",
      type: "editableColumn",
      cellEditor: VendorIdEditorComponent,
      cellEditorParams: {
        vendorOptions,
      },
      valueFormatter: (params) => {
        const option = vendorOptionsRef.current?.find(
          (opt) => opt.value === params.value,
        );
        return option ? option.label : params.value;
      },
    },
    {
      field: "validFrom",
      headerName: "Valid From*",
      type: "editableColumn",
      cellEditor: DateFromEditorComponent,
      cellRenderer: handleDateFormat,
    },
    {
      field: "validTo",
      headerName: "Valid To*",
      type: "editableColumn",
      cellEditor: DateToEditorComponent,
      cellRenderer: handleDateFormat,
    },
    {
      field: "wg1Discount",
      headerName: "WG1 Discount*",
      type: "editableColumn",
      minWidth: 60,
      cellRenderer: showDiscountPercent,
      cellEditor: NumericCellEditorComponent,
      onCellValueChanged: validateDiscount,
    },
    {
      field: "wg2Discount",
      headerName: "WG2 Discount*",
      type: "editableColumn",
      minWidth: 60,
      cellRenderer: showDiscountPercent,
      cellEditor: NumericCellEditorComponent,
      onCellValueChanged: validateDiscount,
    },
    {
      field: "dateType",
      headerName: "Date Type*",
      type: "editableColumn",
      cellEditor: DateTypeEditorComponent,
    },
  ];

  const discountListDropdown = () => (
    <>
      <Box className="w-full">
         
        <CustomDatePicker
          placeholder="Date"
          className="h-[30px]"
          sx={{
            "& .MuiInputBase-root": {
              height: "30px",
              minHeight: "30px",
            },
          }}
          format={"dd-MM-yyyy"}
          name={"Date"}
          value={date}
          handleChange={handleDateChange}
          componentsProps={{
            actionBar: { actions: ["clear"] },
          }}
        />
      </Box>
      <Tooltip title={"Add New Transfer Discount"}>
        <Button variant="contained" color="secondary" onClick={handleAddRow}>
          <FuseSvgIcon>heroicons-solid:plus</FuseSvgIcon>
        </Button>
      </Tooltip>
      <Tooltip title={"Save Transfer Discount"}>
        <Button
          variant="contained"
         color="secondary"
          onClick={() => setSaveOpen(true)}
          disabled={!isSaveEnabled}
        >
          <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
        </Button>
      </Tooltip>
      <Tooltip title={"Edit Transfer Discount"}>
        <Button
          variant="contained"
         color="secondary"
          onClick={handleEditRow}
          disabled={!selectedRow}
        >
          <FuseSvgIcon>heroicons-solid:pencil</FuseSvgIcon>
        </Button>
      </Tooltip>
      <Tooltip title={"Delete Transfer Discount"}>
        <Button
          variant="contained"
         color="secondary"
          onClick={() => setDeleteOpen(true)}
          disabled={!selectedRow}
        >
          <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
        </Button>
      </Tooltip>
    </>
  );
  return (
    <>
      <ListPageHeader
        componentName="Transfer Discount"
        onBtExport={onBtExport}
        pageName="Transfer Discount"
        headerInputFields={discountListDropdown()}
        gridRef={gridRef}
      />

      <div className="h-full">
        <AgGridTable
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          rowSelection="single"
          onSelectionChanged={onSelectionChanged}
          editable={true}
          editType={"fullRow"}
          suppressClickEdit={false}
          onCellEditingStopped={onCellEditingStopped}
          saveGridStateName={"transferDiscountList"}
          autoHeaderHeight
          wrapHeaderText
          tableClassName={"transferDiscountScreen"}
          rowGroupPanelShow="never"
        />
        {/* {totalElements > pageSize && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <Pagination
            count={Math.ceil(totalElements / pageSize)}
            page={page + 1}
            onChange={(e, value) => loadTransferDiscount(value - 1, pageSize)}
            variant="outlined"
          />
        </div>
        )} */}
      </div>

      <Dialog open={saveOpen} onClose={() => setSaveOpen(false)}>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to save discount?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSaveDiscount}>Yes</Button>
          <Button onClick={() => setSaveOpen(false)} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to Delete discount?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDiscount}>Yes</Button>
          <Button onClick={() => setDeleteOpen(false)} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TransferDiscount;
